import React, {useEffect, useRef, useState} from "react";
import Service from "../invite-land/service";
import Styles from "./index.module.scss";
import {Header, ListView} from "../../../../components";

/**
 * @description 土地邀新-邀新记录页
 * @returns route: /front/activities/regularShare/invite-land-record
 */
const InviteLandRecord = () => {
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(true)
  const [hasMore, setHasMore] = useState(false);
  const currentPage = useRef(1);

  useEffect(() => {
    loadData(true);
  }, [])
  const loadData = async (loading = false)=> {
    currentPage.current = 1;
    if (loading) {
      setLoading(true)
    }
    const res = await Service.getInviteList({
      currentPage: currentPage.current,
      type: 1,
    }, loading);
    if (loading) {
      setLoading(false)
    }
    console.log('res', res)
    if (res?.data) {
      const {list = []} = res.data;
      setDataList(list);
      setHasMore(list.length >= Service.PageSize);
    }
  }
  const loadMore = async () => {
    const res = await Service.getInviteList({
      currentPage: currentPage.current + 1,
      type: 1
    }, loading);
    if (res?.data) {
      const {list = []} = res.data;
      setDataList([...dataList, ...list]);
      setHasMore(list.length >= Service.PageSize)
      currentPage.current = currentPage.current + 1;
    }
  }

  const renderItem = (item)=> {
    return (
      <div className={Styles.list_item}>
        <div className={Styles.item_left}>
          <p>{item.mobile}</p>
          <span>{item.createTime}</span>
          <div>{item.productName ?? ''}</div>
        </div>
        <div className={Styles.item_right}>
          <p>{item.inviteStatus}</p>
          {
            item.reason ? <span>{item.reason}</span> : null
          }
        </div>
      </div>
    )
  }

  return (
    <div className={Styles.invite_record}>
      <Header midText={'邀新记录'} shadow/>
      <div className={Styles.record_body}>
        <ListView
          dataSource={dataList}
          emtyDesc={loading ? '数据加载中...' : '暂无数据'}
          renderItem={renderItem}
          hasMore={hasMore}
          onRefresh={loadData}
          loadMore={loadMore}
        />
      </div>
    </div>
  )
}

export {
  InviteLandRecord
}